export default function getURLParameter(name: string): string | string[] | null;
export default function getURLParameter(name: string, forceArrayReturn: true): string[] | null;
export default function getURLParameter(name: string, forceArrayReturn?: boolean): string | string[] | null {
    if (typeof window === "undefined") {
        return null;
    }
    const re = new RegExp('[?&#]' + name + '=([^&#]*)', 'g');
    const results: string[] = [];
    let match;
    while ((match = re.exec(window.location.href))) {
        results.push(match[1]);
    }
    if (!results.length) {
        return null;
    }
    return results.length === 1 && !forceArrayReturn ? results[0] : results;
}